function useRepeatingRuleBoundaryDateWarning({ repeat, frequency, dateStart }) {
  const dateObj = new Date(dateStart);

  if (!dateStart || Number.isNaN(dateObj.getTime())) return "";

  if (repeat === "EVERY" && frequency === "MONTHLY") {
    const dayOfMonth = new Date(dateStart).getDate();

    if (dayOfMonth === 29)
      return (
        "If this rule runs in February, it will only occur during leap years (every 4 years). " +
        "In other months, the rule will run as usual. If February is excluded from the schedule, you can ignore this warning."
      );

    if (dayOfMonth === 30)
      return (
        "This rule will not run in February, as February has fewer than 30 days. " +
        "In other months, the rule will run as usual. If February is excluded from the schedule, you can ignore this warning."
      );

    if (dayOfMonth === 31)
      return (
        "This rule will only run in months with 31 days (January, March, May, July, August, October, December). " +
        "If these months are excluded from the schedule, you can ignore this warning."
      );
  }

  return "";
}

export default useRepeatingRuleBoundaryDateWarning;
